/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Debug_Info_ButtonInputs */

const en_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy debug info`)
};

const id_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin informasi debug`)
};

const ms_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin maklumat nyahpepijat`)
};

const ca_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar informació de depuració`)
};

const cs_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírování informací o ladění`)
};

const da_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiér debug-info`)
};

const de_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debug- Informationen kopieren`)
};

const et_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopeeri silumisinfo`)
};

const es_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar información de depuración`)
};

const fr_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les informations de débogage`)
};

const hr_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj informacije o rješavanju problema`)
};

const it_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia informazioni debug`)
};

const lv_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopēt atkļūdošanas informāciju`)
};

const lt_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nukopijuoti derinimo informaciją`)
};

const hu_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hibakeresési információk másolás`)
};

const nl_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutopsporingsinformatie kopiëren`)
};

const nb_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier feilsøkingsinfo`)
};

const pl_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj informacje o debugowaniu`)
};

const pt_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar informações de depuração`)
};

const ro_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiază informațiile de depanare`)
};

const sk_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovať informácie o ladení`)
};

const sl_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiranje informacij o odpravljanju napak`)
};

const fi_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi viankorjaustiedot`)
};

const sv_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera felsökningsinformation`)
};

const vi_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép thông tin gỡ lỗi`)
};

const tr_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata ayıklama bilgisini kopyala`)
};

const el_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγραφή πληροφοριών εντοπισμού σφαλμάτων`)
};

const bg_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копиране на инфо за дебъгинг`)
};

const ru_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование информации об отладке`)
};

const sr_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирај информације о решавању проблема`)
};

const uk_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопіювати інформацію про налагодження`)
};

const ka_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამართვის ინფორმაციის დაკოპირება`)
};

const hi_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी डिबग इन्फो`)
};

const th_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกข้อมูลการดีบัก`)
};

const ko_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디버그 정보 복사`)
};

const zh_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制调试信息`)
};

const zh_tw_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製除錯資訊`)
};

const ja_copy_debug_info_button = /** @type {(inputs: Copy_Debug_Info_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバッグ情報をコピー`)
};

/**
* | output |
* | --- |
* | "Copy debug info" |
*
* @param {Copy_Debug_Info_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copy_debug_info_button = /** @type {((inputs?: Copy_Debug_Info_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Debug_Info_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copy_debug_info_button(inputs)
	if (locale === "ms") return ms_copy_debug_info_button(inputs)
	if (locale === "ca") return ca_copy_debug_info_button(inputs)
	if (locale === "cs") return cs_copy_debug_info_button(inputs)
	if (locale === "da") return da_copy_debug_info_button(inputs)
	if (locale === "de") return de_copy_debug_info_button(inputs)
	if (locale === "et") return et_copy_debug_info_button(inputs)
	if (locale === "es") return es_copy_debug_info_button(inputs)
	if (locale === "fr") return fr_copy_debug_info_button(inputs)
	if (locale === "hr") return hr_copy_debug_info_button(inputs)
	if (locale === "it") return it_copy_debug_info_button(inputs)
	if (locale === "lv") return lv_copy_debug_info_button(inputs)
	if (locale === "lt") return lt_copy_debug_info_button(inputs)
	if (locale === "hu") return hu_copy_debug_info_button(inputs)
	if (locale === "nl") return nl_copy_debug_info_button(inputs)
	if (locale === "nb") return nb_copy_debug_info_button(inputs)
	if (locale === "pl") return pl_copy_debug_info_button(inputs)
	if (locale === "pt") return pt_copy_debug_info_button(inputs)
	if (locale === "ro") return ro_copy_debug_info_button(inputs)
	if (locale === "sk") return sk_copy_debug_info_button(inputs)
	if (locale === "sl") return sl_copy_debug_info_button(inputs)
	if (locale === "fi") return fi_copy_debug_info_button(inputs)
	if (locale === "sv") return sv_copy_debug_info_button(inputs)
	if (locale === "vi") return vi_copy_debug_info_button(inputs)
	if (locale === "tr") return tr_copy_debug_info_button(inputs)
	if (locale === "el") return el_copy_debug_info_button(inputs)
	if (locale === "bg") return bg_copy_debug_info_button(inputs)
	if (locale === "ru") return ru_copy_debug_info_button(inputs)
	if (locale === "sr") return sr_copy_debug_info_button(inputs)
	if (locale === "uk") return uk_copy_debug_info_button(inputs)
	if (locale === "ka") return ka_copy_debug_info_button(inputs)
	if (locale === "hi") return hi_copy_debug_info_button(inputs)
	if (locale === "th") return th_copy_debug_info_button(inputs)
	if (locale === "ko") return ko_copy_debug_info_button(inputs)
	if (locale === "zh") return zh_copy_debug_info_button(inputs)
	if (locale === "zh-tw") return zh_tw_copy_debug_info_button(inputs)
	if (locale === "ja") return ja_copy_debug_info_button(inputs)
	return en_copy_debug_info_button(inputs)
});